import angular from 'angular';
import '../../shared.module';
import template from './card.component.html';
import './card.component.scss';

class CardController {}

angular.module('app.shared').component('cpCard', {
  bindings: {
    title: '@',
    subtitle: '@',
    noPadding: '<'
  },
  transclude: {
    body: '?cpCardBody',
    actions: '?cpCardActions'
  },
  controller: CardController,
  controllerAs: 'vm',
  template
});
